import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DateTimePicker.css';
import { Calendar, Clock } from 'lucide-react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

interface DateTimePickerProps {
  value?: Date | null;
  onChange: (date: Date | null) => void;
  placeholder?: string;
  className?: string;
  showTimeSelect?: boolean;
  dateFormat?: string;
  minDate?: Date;
  maxDate?: Date;
  disabled?: boolean;
}

export const DateTimePicker: React.FC<DateTimePickerProps> = ({
  value,
  onChange,
  placeholder = 'Seleccionar fecha y hora', // TODO: Translate
  className = '',
  showTimeSelect = false,
  dateFormat = 'dd/MM/yyyy',
  minDate,
  maxDate,
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleChange = (date: Date | null) => {
    onChange(date);
    if (date) {
      setIsOpen(false);
    }
  };

  const formatDisplayValue = (date: Date | null | undefined): string => {
    if (!date) return '';
    return format(date, dateFormat, { locale: es });
  };

  return (
    <div className="relative">
      <div className="relative">
        <input
          type="text"
          value={formatDisplayValue(value)}
          placeholder={placeholder}
          onClick={() => !disabled && setIsOpen(true)}
          readOnly
          disabled={disabled}
          className={`w-full rounded-md border-2 border-gray-300 shadow-sm bg-gray-10 focus:border-brand-orange focus:ring-brand-orange pr-10 cursor-pointer ${
            disabled ? 'bg-gray-100 cursor-not-allowed' : ''
          } ${className}`}
        />
        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
          {showTimeSelect ? (
            <Clock className="h-5 w-5 text-gray-400" />
          ) : (
            <Calendar className="h-5 w-5 text-gray-400" />
          )}
        </div>
      </div>

      {isOpen && !disabled && (
        <div className="absolute z-50 mt-1">
          <DatePicker
            selected={value}
            onChange={handleChange}
            showTimeSelect={showTimeSelect}
            timeFormat="HH:mm"
            timeIntervals={15}
            dateFormat={dateFormat}
            locale={es}
            minDate={minDate}
            maxDate={maxDate}
            inline
            popperClassName="z-50"
            customInput={<div />}
            onClickOutside={() => setIsOpen(false)}
            onKeyDown={(e) => {
              if (e.key === 'Escape') {
                setIsOpen(false);
              }
            }}
          />
        </div>
      )}
    </div>
  );
}; 